export default "__VITE_ASSET__b6593325__"